import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import PropTypes from "prop-types";
import { isNull } from "App/utils/helpers";

export default function MasterButton(props) {
  const {
    name,
    type = "submit",
    outline = false,
    color,
    size = "sm",
    className,
    disabled,
    withIcon = false,
    icon,
    buttonName = "",
    ...other
  } = props;

  let colorType = "#296218";

  switch (color) {
    case "green":
      colorType = "#296218";
      break;
    case "warning":
      colorType = "#F09F00";
      break;
    case "lightgreen":
      colorType = "#0FB054";
      break;
    case "danger":
      colorType = "#CC2B1D";
      break;
    case "secondary":
      colorType = "#D8D8D8";
      break;
    case "purple":
      colorType = "#a855f7";
      break;
    case "primary-cyan":
      colorType = "#0891b2";
      break;
    case "indigo":
      colorType = "#6366f1";
      break;
    case "cyan":
      colorType = "#06b6d4";
      break;
    case "blue":
      colorType = "#00b0f2";
      break;
    default:
      colorType = "#296218";
      break;
  }

  let padding = "2px 24px";
  switch (size) {
    case "xs":
      padding = "0.2rem 0.8rem";
      break;
    case "sm":
      padding = "0.3rem 1rem";
      break;
    case "md":
      padding = "0.4rem 1rem";
      break;
    case "lg":
      padding = "0.5rem 1rem";
      break;
    default:
      padding = "2px 24px";
      break;
  }

  const useMasterButtonStyle = makeStyles(() => ({
    root: {
      fontWeight: "600",
      fontSize: "10px",
      padding: padding,
      borderRadius: "6px",
      cursor: "pointer",
      transition: "all 0.3s ease",
      "&:hover": {
        background: colorType,
        color: "#fff",
        opacity: outline ? "1" : "0.8",
      },
    },
    outlineBtn: {
      color: colorType,
      border: `1px solid ${colorType}`,
      backgroundColor: "transparent",
    },
    basicBtn: {
      backgroundColor: colorType,
      border: 0,
      color: "#fff",
    },
    iconButton: {
      display: "flex",
      alignItems: "center",
    },
  }));

  const classes = useMasterButtonStyle();

  return (
    <button
      type={type}
      className={clsx(
        classes.root,
        outline ? classes.outlineBtn : classes.basicBtn,
        className
      )}
      disabled={`${disabled ? "disabled" : ""}`}
      // disabled={"disabled"}
      name={buttonName}
      {...other}>
      <div className={classes.iconButton}>
        {withIcon && <span className={classes.iconButton}>{icon}</span>}
        <span
          style={{
            marginLeft: isNull(name) ? 0 : withIcon ? "5px" : 0,
          }}>
          {name}
        </span>
      </div>
    </button>
  );
}

MasterButton.propTypes = {
  name: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  type: PropTypes.string,
  icon: PropTypes.node,
  withIcon: PropTypes.bool,
};
